.pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  line-height: 135%;
  white-space: nowrap;
  width: fit-content;
}
